module.exports = __webpack_public_path__ + "media/belt-driven-tragedy.f9a8191d.mp3";